import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import CompanyName from '../../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import DecisionWithQuality from '../../../commonComponents/DecisionWithQuality';
import { DecisionWithQualityType } from '../../../../static/types/commonTypes/decisionWithQualityType';
import LegalEntity from '../../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../../static/types/commonTypes/legalEntityType';
import ChangeManagementAndPresidency from './ChangeManagementAndPresidency';
import ChangeDenomination from './ChangeDenomination';
import ChangeObject from './ChangeObject';
import ChangeShareCapital from './ChangeShareCapital';
import ChangeDuration from './ChangeDuration';
import ChangeAuditor from './ChangeAuditor';
import IntraResortSeatTransfer from './IntraResortSeatTransfer';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import Swal from 'sweetalert2';
import { ManagerType, ManagerTypeWithQualite, ReducedManagerTypeWithQuality } from '../../../../static/types/commonTypes/managerType';
import { advencedFunctions } from '../../../../constant/company-modification/functions';
import { ReducedManagerType } from '../../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const ModificationsMultiples: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateDenomination,
    updateActiveIndex,
    societyType,

}) => {
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [ submissive, setSubmissive ] = useState<boolean>( false );

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        decisionWithQuality, setDecisionWithQuality,
        decisionWithQualityValidity, setDecisionWithQualityValidity,
        decisionWithQualityChecked, setDecisionWithQualityChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,
        
        setReducedGeneralManagersWithQualiteChecked,
        reducedGeneralManagersWithQualiteValidity,

        generalManagersWithQualiteValidity,
        setGeneralManagersWithQualiteChecked,

        managerWithQualityValidity,
        setManagerWithQualityChecked,
        
        oldCapitalChangeValidity,
        setOldCapitalChangeChecked,

        newCapitalChangeValidity,
        setNewCapitalChangeChecked,

        auditorChangeEffectiveDate,
        newStatutoryAuditor, 
        newStatutoryAuditorValidity, 
        setNewStatutoryAuditorChecked,

        newAlternateAuditor, 
        newAlternateAuditorValidity, 
        setNewAlternateAuditorChecked,
        typeNewAlternateAuditorData, 

        formerStatutoryAuditor, 
        formerStatutoryAuditorValidity, 
        setFormerStatutoryAuditorChecked,

        formerAlternateAuditor, 
        formerAlternateAuditorValidity, 
        setFormerAlternateAuditorChecked, 
        typeFormerAlternateAuditorData, 

        addressValidity,
        setAddressChecked,
        
        reducedStatutoryAuditor, 
        reducedStatutoryAuditorValidity, 
        setReducedStatutoryAuditorChecked,

        reducedGeneralManagersWithQualite,
        managerWithQuality,
        generalManagersWithQualite,

        managerAndPresidencyChange,
        companyNameChange,
        socialObjectChange,
        socialCapitalChange,
        durationChange,
        auditorChange,
        seatTransfertChange,

        presidencyChangeEffectiveDate,
        companyNameChangeEffectiveDate,
        companyNameUpdate,

        socialObjectChangeEffectiveDate,
        changeSocialObject,
        
        socialCapitalChangeEffectiveDate,
        
        oldCapitalChange,
        newCapitalChange,
        
        durationChangeEffectiveDate,
        durationChangeDate,

        address,
        seatTransfertChangeEffectiveDate,
        
    } = useAppContext() as AppContextType
    
    const presidencyChangeValidity = (): boolean => {
        let res = false
        if( managerAndPresidencyChange === 0 ) res = true
        else if( managerAndPresidencyChange === 1 ) res = reducedGeneralManagersWithQualiteValidity
        else if ( managerAndPresidencyChange === 2 ) res = managerWithQualityValidity && reducedStatutoryAuditorValidity
        else if ( managerAndPresidencyChange === 3 ) res = generalManagersWithQualiteValidity
        return res
    }

    const capitalChangeValidity = (): boolean => {
        let res = false
        if( socialCapitalChange === 0 ) res = true
        else if( managerAndPresidencyChange !== 0 ) res = oldCapitalChangeValidity && newCapitalChangeValidity
        return res
    }

    const auditorValidity = (): boolean => {

        let res = false

        if ( auditorChange === 0 ) res = true
        else if ( auditorChange === 1 ) {
            if( typeNewAlternateAuditorData === 1 ) res =  newStatutoryAuditorValidity && newAlternateAuditorValidity
            else res = newStatutoryAuditorValidity
        }
        else if ( auditorChange ===  2) {
            if( typeFormerAlternateAuditorData === 1 ){
                res = formerStatutoryAuditorValidity && formerAlternateAuditorValidity
            }
            else res = formerStatutoryAuditorValidity
        }
        else if (auditorChange === 3) {
            res = newStatutoryAuditorValidity && formerStatutoryAuditorValidity
        }
        else if (auditorChange === 4) {
                if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                    res = newAlternateAuditorValidity && formerAlternateAuditorValidity
                }
                else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0 ){
                    res = newAlternateAuditorValidity
                }
                else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1 ){
                    res = formerAlternateAuditorValidity
                }
                else res = true
        }
        else if (auditorChange === 5) {
            if( newStatutoryAuditorValidity && formerStatutoryAuditorValidity ){
                if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                    res = newAlternateAuditorValidity && formerAlternateAuditorValidity
                }
                else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0 ){
                    res = newAlternateAuditorValidity
                }
                else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1 ){
                    res = formerAlternateAuditorValidity
                }
                else res = true
            }
        }
        return res
    }

    const seatTransfertChangeValidity = (): boolean => {
        let res = false
        if( seatTransfertChange === 0 ) res = true
        else res = addressValidity
        return res
    }

    const validate = () => {

        const temp_presidencyChangeValidity = presidencyChangeValidity()
        const temp_socialCapitalChangeValidity = capitalChangeValidity()
        const temp_auditorChangeValidity = auditorValidity()
        const temp_seatTransfertChangeValidity = seatTransfertChangeValidity()

        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!decisionWithQualityValidity) {
            setActiveTab('decision')
        } else if (!legalEntityValidity) {
            setActiveTab('theSociety')
        } else if (!temp_presidencyChangeValidity) {
            setActiveTab('changeManagementAndPresidency')
        } else if (!temp_socialCapitalChangeValidity) {
            setActiveTab('changeCapital')
        } else if (!temp_auditorChangeValidity) {
            setActiveTab('auditor')
        }  else if (!temp_seatTransfertChangeValidity) {
            setActiveTab('intraResortSeatTransfer')
        }

        return companyNameValidity && decisionWithQualityValidity && legalEntity && temp_presidencyChangeValidity && temp_socialCapitalChangeValidity && temp_auditorChangeValidity && temp_seatTransfertChangeValidity;
    }
    
    const handleNext = () => {
        if ( activeTab === "companyName" ) {
            setCompanyNameChecked (true)
            if(companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if ( activeTab === "decision" ) {
            setDecisionWithQualityChecked (true)
            if (decisionWithQualityValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if ( activeTab === "theSociety" ) {
            setLegalEntityChecked(true)
            if(legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if ( activeTab === "changeManagementAndPresidency" ){
            
            if( managerAndPresidencyChange === 1 ){
                setReducedGeneralManagersWithQualiteChecked( true )
                if( reducedGeneralManagersWithQualiteValidity ){
                    switchTab(getNextTab("changeManagementAndPresidency"));
                }
            }

            else if( managerAndPresidencyChange === 2 ){
                setManagerWithQualityChecked (true)
                setReducedStatutoryAuditorChecked( true )
                if( managerWithQualityValidity && reducedStatutoryAuditorValidity ){
                    switchTab(getNextTab("changeManagementAndPresidency"));
                }
            }

            else if( managerAndPresidencyChange === 3 ){
                setGeneralManagersWithQualiteChecked (true)
                if( generalManagersWithQualiteValidity ){
                    switchTab(getNextTab("changeManagementAndPresidency"));
                }
            }

            else switchTab(getNextTab("changeManagementAndPresidency"));
        } else if ( activeTab === "changeDenomination" ) {
            switchTab(getNextTab("changeDenomination"));
        } else if (activeTab === "changeObject") {
            switchTab(getNextTab("changeObject"));
        } else if (activeTab === "changeShareCapital") {
            if (socialCapitalChange === 1 || socialCapitalChange === 2) {
                setOldCapitalChangeChecked (true)
                setNewCapitalChangeChecked (true)
                if (oldCapitalChangeValidity && newCapitalChangeValidity) {
                    switchTab(getNextTab("changeShareCapital"));
                }
            } else switchTab(getNextTab("changeShareCapital"));
        } else if (activeTab === "changeDuration") {
            if (durationChange === 1) {
                switchTab(getNextTab("changeDuration"));
            } else switchTab(getNextTab("changeDuration"));
        } else if (activeTab === "changeAuditor") {
            if (auditorChange === 1) {
                setNewStatutoryAuditorChecked( true )
                if( typeNewAlternateAuditorData === 1 ){
                    setNewAlternateAuditorChecked( true )
                    if( newStatutoryAuditorValidity && newAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                }
                else if( newStatutoryAuditorValidity ) switchTab(getNextTab("changeAuditor"));
            } else if (auditorChange === 2) {
                setFormerStatutoryAuditorChecked( true )
                if( typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                }
                else if( formerStatutoryAuditorValidity ) switchTab(getNextTab("changeAuditor"));
            } else if (auditorChange === 3) {
                setNewStatutoryAuditorChecked( true )
                setFormerStatutoryAuditorChecked( true )
                if( newStatutoryAuditorValidity && formerStatutoryAuditorValidity ){
                    switchTab(getNextTab("changeAuditor"));
                }
            } else if (auditorChange === 4) {
                if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                    setNewAlternateAuditorChecked( true )
                    setFormerAlternateAuditorChecked( true )
                    if( newAlternateAuditorValidity && formerAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                }
                else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0 ){
                    setNewAlternateAuditorChecked( true )
                    if( newAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                }
                else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                }
                else switchTab(getNextTab("changeAuditor"));
            } else if (auditorChange === 5) {
                setNewStatutoryAuditorChecked( true )
                setFormerStatutoryAuditorChecked( true )
                if( newStatutoryAuditorValidity && formerStatutoryAuditorValidity ){
                    if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                        if( newAlternateAuditorValidity && formerAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                    }
                    else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0 ){
                        if( newAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                    }
                    else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1 ){
                        if( formerAlternateAuditorValidity ) switchTab(getNextTab("changeAuditor"));
                    }
                    else switchTab(getNextTab("changeAuditor"));
                }
            } else switchTab(getNextTab("changeAuditor"));
        } else if (activeTab === "intraResortSeatTransfer") {
           if (seatTransfertChange === 1) {
            setAddressChecked (true)
            if (addressValidity) {
                    setSubmissive (true)
                } 
           } else setSubmissive (true)
        }
        
    }

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive ( false )
    }

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "decision";
        else if (currentTab === "decision") return "theSociety";
        else if (currentTab === "theSociety") return "changeManagementAndPresidency";
        else if (currentTab === "changeManagementAndPresidency") return "changeDenomination";
        else if (currentTab === "changeDenomination") return "changeObject";
        else if (currentTab === "changeObject") return "changeShareCapital";
        else if (currentTab === "changeShareCapital") return "changeDuration";
        else if (currentTab === "changeDuration") return "changeAuditor";
        else if (currentTab === "changeAuditor") return "intraResortSeatTransfer";
        return currentTab;
    }

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "intraResortSeatTransfer") return "changeAuditor";
        else if (currentTab === "changeAuditor") return "changeDuration";
        else if (currentTab === "changeDuration") return "changeShareCapital";
        else if (currentTab === "changeShareCapital") return "changeObject";
        else if (currentTab === "changeObject") return "changeDenomination";
        else if (currentTab === "changeDenomination") return "changeManagementAndPresidency";
        else if (currentTab === "changeManagementAndPresidency") return "theSociety";
        else if (currentTab === "theSociety") return "decision";
        else if (currentTab === "decision") return "companyName";
        return currentTab;
    }

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName ({...companyName, ...data});

    const updateDecision = (data: Partial<DecisionWithQualityType>) => setDecisionWithQuality ({...decisionWithQuality, ...data});

    const updateLegaEntity = ( partialData: Partial<LegalEntityType> ) => setLegalEntity({ ...legalEntity, ...partialData })

    
    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const reducedManagerText = ( manager: ReducedManagerTypeWithQuality | ReducedManagerType ): string => {
        if( manager.person === "Personne physique" ){
            return ` ${ manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme' } ${ manager.personDetails.lastName } ${ manager.personDetails.firstName }` 
        }
        else if( manager.person === "Personne morale" ){
            return `${ manager.entityDetails.companyName }`
        }
        else return ''
    }

    const managerText = ( manager: ManagerTypeWithQualite | ManagerType ): string => {
        if( manager.person === "Personne morale" ){
            return manager.entityDetails.rcs ? ` ${ manager.entityDetails.companyName }, ${ manager.entityDetails.legalForm } au capital de ${ manager.entityDetails.capital } €, ayant son siège social ${ manager.entityDetails.address } ${ manager.entityDetails.additionalAddress ?? "" } ${ manager.entityDetails.postalCode } ${ manager.entityDetails.city }, ${ manager.entityDetails.rcs } RCS ${ getCityWithPreposition( manager.entityDetails.registrationOffice )}` : ``
        }
        else if( manager.person === "Personne physique" ){
            return manager.personDetails.lastName ? ` ${ manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme' } ${ manager.personDetails.lastName } ${ manager.personDetails.firstName }, demeurant ${ manager.personDetails.address } ${ manager.personDetails.additionalAddress ?? "" } ${ manager.personDetails.postalCode } ${ manager.personDetails.city }` : `` 
        }
        else return ""
    }

    const presidencyChangeText = (): string => {

        let res = ``

        const effectiveDateText = presidencyChangeEffectiveDate.date ? `, à compter du ${ presidencyChangeEffectiveDate.date }` : ``

        const processReducedManagersData = ( reducedManagersData: ReducedManagerTypeWithQuality[] ): {[key:string]: Array<ReducedManagerTypeWithQuality> } => {
            return reducedManagersData.reduce((accumulator: {[key:string]: Array<ReducedManagerTypeWithQuality> }, currentManager: ReducedManagerTypeWithQuality ) => {
                if( accumulator[currentManager.qualite ]) {
                    accumulator[currentManager.qualite ] = [ ...accumulator[currentManager.qualite ], currentManager ]
                }
                else{
                    accumulator[currentManager.qualite] = [ currentManager ]
                }
                return accumulator
            }, {})
        }
        
        const processManagersData = ( managersData: ManagerTypeWithQualite[] ): {[key:string]: Array< ManagerTypeWithQualite> } => {
            return managersData.reduce((accumulator: {[key:string]: Array< ManagerTypeWithQualite> }, currentManager: ManagerTypeWithQualite ) => {
                if( accumulator[currentManager.qualite ]) {
                    accumulator[currentManager.qualite ] = [ ...accumulator[currentManager.qualite ], currentManager ]
                }
                else{
                    accumulator[currentManager.qualite] = [ currentManager ]
                }
                return accumulator
            }, {})
        }

        const getQualityPlural = ( quality: string ): string => {
            return advencedFunctions.find( advencedFunction => advencedFunction.singular === quality )?.plural ?? ''
        }

        const processedReducedManagersData = processReducedManagersData( reducedGeneralManagersWithQualite )
        const processedManagersData = processManagersData( generalManagersWithQualite )

        if( managerAndPresidencyChange === 1 ){
            res = `${ Object.keys( processedReducedManagersData ).map( currentQuality => `
- Prendre acte de la cessation des fonctions de ${ processedReducedManagersData[currentQuality].length > 1 ? getQualityPlural( currentQuality) : currentQuality } de ${ processedReducedManagersData[ currentQuality ].map( currentManager => reducedManagerText( currentManager )).join(" et ")}`)}`
        }
        else if( managerAndPresidencyChange === 2 ){
            res = `- Nommer${ effectiveDateText } ${ managerWithQuality.qualite } ${ managerText( managerWithQuality )}, en remplacement de ${ reducedManagerText( reducedStatutoryAuditor )}`
        }
        else if( managerAndPresidencyChange === 3 ){
            res = `${ Object.keys( processedManagersData ).map( currentQuality => `
- Nommer${ effectiveDateText } ${ processedManagersData[currentQuality].length > 1 ? getQualityPlural( currentQuality) : currentQuality } ${ processedManagersData[ currentQuality ].map( currentManager => managerText( currentManager )).join(" et ")}`)}`
        }
        return res
    }

    const companyNameChangeText = (): string => {
        let res = ``
        if( companyNameChange !== 0 && companyNameUpdate.companyName ){
            res = `- Modifier la dénomination qui devient : ${ companyNameUpdate.companyName }${ companyNameChangeEffectiveDate.date ? `, à compter du ${ companyNameChangeEffectiveDate.date }` : '' }.`
        }
        return res
    }

    const socialObjectChangeText = (): string => {
        let res = ``
        if( changeSocialObject.socialObject ){
            if( socialObjectChange === 1 ) res = `- Modifier l'objet en ajoutant les activités suivantes : ${ changeSocialObject.socialObject }${ socialObjectChangeEffectiveDate.date ? `, à compter du ${ socialObjectChangeEffectiveDate.date }` : '' }.`

            else if( socialObjectChange === 2 ) res = `- Modifier l'objet qui devient : ${ changeSocialObject.socialObject }${ socialObjectChangeEffectiveDate.date ? `, à compter du ${ socialObjectChangeEffectiveDate.date }` : '' }.`
        }
        return res
    }

    const socialCapitalChangeText = (): string => {

        let res = ``

        if( socialCapitalChange === 1 ) res = `- Augmenter le capital social de ${ oldCapitalChange.capital } € à ${ newCapitalChange.capital } €${ socialCapitalChangeEffectiveDate.date ? `, à compter du ${ socialCapitalChangeEffectiveDate.date }` : '' }.`

        else if( socialCapitalChange === 2 ) res = `- Diminuer le capital social de ${ oldCapitalChange.capital } € à ${ newCapitalChange.capital } €${ socialCapitalChangeEffectiveDate.date ? `, à compter du ${ socialCapitalChangeEffectiveDate.date }` : '' }.`

        return res
    }

    const durationChangeText = (): string => {
        let res = ``
        if( durationChange !== 0 && durationChangeDate.date ){
            res = `- Proroger la durée jusqu'au ${ durationChangeDate.date }${ durationChangeEffectiveDate.date ? `, à compter du ${ durationChangeEffectiveDate.date }` : '' }.`
        }
        return res
    }

    const seatTransfertChangeText = (): string => {
        let res = ``
        if( seatTransfertChange !== 0 ){
            res = `- Transférer le siège social ${ address.address } ${ address.additionalAddress ? address.additionalAddress : '' } ${ address.postalCode } ${ address.city }${ companyNameChangeEffectiveDate.date ? `, à compter du ${ seatTransfertChangeEffectiveDate.date }` : '' }.`
        }
        return res
    }

    const auditorText = (): string => {

        const effectiveDateText = auditorChangeEffectiveDate.date ? `, à compter du ${ auditorChangeEffectiveDate.date }` : ``

        let res = ``

        if( auditorChange === 1 ){
            res = typeNewAlternateAuditorData === 1
            ? `Nommer${ effectiveDateText } Commissaires Aux Comptes Titulaire et Suppléant respectivement : ${ managerText( newStatutoryAuditor )} et ${ managerText( newAlternateAuditor )}.`
            : `Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire, ${ managerText( newStatutoryAuditor )}.`
        }
        else if( auditorChange === 2 ){
            res = typeFormerAlternateAuditorData === 1
            ? `Prendre acte de la cessation des fonctions des Commissaires Aux Comptes Titulaire et Suppléant respectivement, ${ reducedManagerText( formerStatutoryAuditor )} et ${ reducedManagerText( formerAlternateAuditor )}.`
            : `Prender acte de la cessation des fonctions du Commissaire Aux Comptes Titulaire, ${ reducedManagerText( formerStatutoryAuditor )}.`
        }
        else if( auditorChange === 3 ){
            res = `Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire : ${ managerText( newStatutoryAuditor )}, en remplacement de ${ reducedManagerText( formerStatutoryAuditor )}.`
        }
        else if( auditorChange === 4 ){
            res = `Nommé${ effectiveDateText } Commissaire Aux Comptes Suppléant : ${ managerText( newAlternateAuditor )}, en remplacement de ${ reducedManagerText( formerAlternateAuditor )}.`
        }
        else if( auditorChange === 5 ){
            if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 0 )
            res = `Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire : ${ managerText( newAlternateAuditor )}, en remplacement de ${ reducedManagerText( formerAlternateAuditor )}.`
        
            else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 )
            res = `- Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire : ${ managerText( newStatutoryAuditor )}, en remplacement de ${ reducedManagerText( formerStatutoryAuditor )}
- Nommer ${ effectiveDateText } Commissaire Aux Comptes Suppléant : ${ managerText( newAlternateAuditor )}, en remplacement de ${ reducedManagerText( formerAlternateAuditor )}`
        
            else if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0 )
            res = `- Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire : ${ managerText( newStatutoryAuditor )}, en remplacement de ${ reducedManagerText( formerStatutoryAuditor )}.
- Nommer ${ effectiveDateText } Commissaire Aux Comptes Suppléant : ${ managerText( newAlternateAuditor )}.`
        
            else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 0 )
            res = `- Nommer${ effectiveDateText } Commissaire Aux Comptes Titulaire : ${ managerText( newStatutoryAuditor )}, en remplacement de ${ reducedManagerText( formerStatutoryAuditor )}.
- Prendre acte de la cessation des fonctions des Commissaires Aux Comptes Suppléant, ${ reducedManagerText( formerAlternateAuditor )}.`
        }
        return res
    }

    const handleSubmit = (e: React.FormEvent) => {
   
        e.preventDefault();

        const atLeastTwoModification: boolean =
        [
            managerAndPresidencyChange,
            companyNameChange,
            socialObjectChange,
            socialCapitalChange,
            durationChange,
            auditorChange,
            seatTransfertChange
        ].filter(( value: number ) => value !== 0 ).length >= 2
   
        if( atLeastTwoModification ){

            const decisionChange = decisionWithQuality.decisionNature === "AG Extraordinaire"
            ? "AGE"
            : decisionWithQuality.decisionNature === "AG Ordinaire"
                ? "AGO"
                : decisionWithQuality.decisionNature === "AG Mixte"
                    ? "AG Mixte"
                    : decisionWithQuality.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQuality.decisionNature) ? `Aux termes de l'${decisionChange} en date du ${decisionWithQuality.decisionDate} ${decisionWithQuality.decisionQuality.toLowerCase()} ${ decisionWithQuality.decisionQuality.toLocaleLowerCase().includes("les") ? "ont" : "a" } décidé de :` : `Le ${decisionWithQuality.decisionDate}, ${decisionWithQuality.decisionNature.toLowerCase()} a décidé de :`;

            if (validate()) {
   
                const tempText = `${ legalEntity.companyName }
${ legalEntity.legalForm } au capital de ${ legalEntity.capital } €,
Siège social :
${ legalEntity.address } ${ legalEntity.additionalAddress ?? "" } ${ legalEntity.postalCode } ${ legalEntity.city }
${ legalEntity.rcs } RCS ${ getCityWithPreposition( legalEntity.registrationOffice )}
${ decisionText } ${ managerAndPresidencyChange === 0 ? '' : `${ presidencyChangeText() }`} ${( companyNameChange === 0 || !companyNameUpdate.companyName ) ? '' : `
${ companyNameChangeText() }` } ${( socialObjectChange === 0 || !changeSocialObject.socialObject) ? '' : `
${ socialObjectChangeText() }`} ${ socialCapitalChange === 0 ? '' : `
${ socialCapitalChangeText() }`} ${( durationChange === 0 || !durationChangeDate.date) ? '' : `
${ durationChangeText()}`} ${ auditorChange === 0 ? '' : `
${ auditorText()}`} ${ seatTransfertChange === 0 ? '' : `
${ seatTransfertChangeText()}`}
Mention au RCS ${ getCityWithPreposition( legalEntity.registrationOffice )}.`
    
                const formattedText = formatObjectText(tempText);
                updateTxtAnnonce(formattedText);
                updateDenomination (companyName.companyName);
                setSubmissive (true)
            }
        }
        else {
            setSubmissive( false )
            Swal.fire({
                title: "Modifications multiples",
                text: "Merci de bien vouloir effectuer au moins deux modifications avant de passer à l'étape suivante!",
                icon: "warning",
                animation: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
                confirmButtonColor: "#2A919D"
            })
        }
    };

    const tabs = [
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'decision', label: "Choisir l'organe et la date de la décision"},
        {key: 'theSociety', label: 'La société'},
        {key: 'changeManagementAndPresidency', label: 'Modification de la gérance / présidence'},
        {key: 'changeDenomination', label: 'Modification de dénomination'},
        {key: 'changeObject', label: "Modification d'objet social"},
        {key: 'changeShareCapital', label: 'Modification du capital social'},
        {key: 'changeDuration', label: 'Modification de durée'},
        {key: 'changeAuditor', label: 'Commissaires aux comptes'},
        {key: 'intraResortSeatTransfer', label: 'Transfert de siège intra-ressort'},
    
    ]
    return (
        <>     
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={ updateCompanyName }
                        checked = {companyNameChecked}
                        companyName= {companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity (isValid)}
                        showClientReference= {true}
                    />
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality = { decisionWithQuality }
                        draftFieldName = 'decisionWithQuality'
                        checked = {decisionWithQualityChecked}
                        dateLabel ='Date'
                        changeDecision = { updateDecision }
                        onValidationChange = {( isValid: boolean ) => setDecisionWithQualityValidity ( isValid )}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity = { updateLegaEntity }
                        checked = { legalEntityChecked }
                        legalEntity = { legalEntity }
                        onValidationChange = {( isValid: boolean ) => setLegalEntityValidity( isValid )}
                        companyName = { companyName }
                        setCompanyName = { updateCompanyName }
                        societyType = { societyTypeOptions }
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'changeManagementAndPresidency' &&
                    <ChangeManagementAndPresidency
                        societyTypeOptions = { societyTypeOptions }
                    />
                } 

                {
                    activeTab === 'changeDenomination' &&
                    <ChangeDenomination />
                }   

                {
                    activeTab === 'changeObject' &&
                    <ChangeObject />
                }

                {
                    activeTab === 'changeShareCapital' &&
                    <ChangeShareCapital />
                }

                {
                    activeTab === 'changeDuration' &&
                    <ChangeDuration />
                }

                {
                    activeTab === 'changeAuditor' &&
                    <ChangeAuditor societyType={societyTypeOptions} />
                }

                {
                    activeTab === 'intraResortSeatTransfer' &&
                    <IntraResortSeatTransfer />
                }

                {
                    submissive &&
                    activeTab === 'intraResortSeatTransfer' && 
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={ txtAnnonce }
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px',fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                        )}

                        {
                            activeTab === 'intraResortSeatTransfer' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            activeTab !== 'intraResortSeatTransfer' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            submissive && activeTab === 'intraResortSeatTransfer' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )} 
                    </div>
                </div>
            </form> 
        </>
    );
};

export default ModificationsMultiples;